export const es = {
    "TRIGGER_LISTEN": "Escuchando los desencadenantes",
    "ASSIST_EMPTY_MSG": "Agent AI está escuchando activamente su conversación y está listo para ayudar automáticamente cuando se active.",
    "MYBOT_TRIGGET_LISTEN": "No hay tareas activas de My Bot en este momento.",
    "MYBOT_EMTPY_MSG": "Para iniciar una tarea en My Bot, vaya a la pestaña de búsqueda y seleccione la opción \"Ejecutar con las entradas del agente\" para la tarea deseada.",
    "PROACTIVE_MODE": "Modo Proactivo",
    "SETTINGS": "Configuración",
    "HELP_AND_SUPPORT": "Ayuda y Soporte",
    "AUTOSCROLL_ASSIST":"Asistencia de desplazamiento automático",
    "HELP": "Ayuda",
    "LANGUAGE": "Idioma",
    "ASK_A_QUESTION":"Haz una pregunta",
    "THEME": "Tema",
    "FILE_NAME":"Nombre de archivo",
    "AUTOMATIC": "Automático",
    "AUTO_SCROLL_TOOLTIP":"Controla el desplazamiento automático de la pestaña Asistencia, Mi bot y el contenido de la pestaña Transcripción",
    "DARK": "Oscuro",
    "LIGHT": "Claro",
    "THEME_DESC": "Esto usará el modo predeterminado de su sistema.",
    "DOCUMENTATION": "Documentación",
    "DOC_DESC": "Consulte nuestros artículos de documentación detallados.",
    "FAQ_U": "FAQ",
    "FAQ_DESC": "Consulte las preguntas frecuentes sobre Agent AI.",
    "KORE_ACADEMY": "Academia Kore",
    "KORE_ACA_DESC": "Obtenga más información sobre Agent AI mediante los cursos de la academia.",
    "SEARCH": "Búsqueda",
    "MY_BOT": "Mi Bot",
    "ASSIST": "Asistencia",
    "TRANSCRIPT": "Transcripción",
    "TAP_SEARCH":"Toca para buscar",
    "HISTORY": "Historial",
    "STARTOVER": "Empezar de nuevo",
    "RESTART_INPUTS": "Reiniciar con las entradas capturadas",
    "ASKCUSTOMER": "Preguntar al cliente",
    "TELLCUSTOMER": "Decir al cliente",
    "WELCOME_MSG": "Mensaje de bienvenida",
    "SEND": "Enviar",
    "SENT": "Enviado",
    "AWAITING": "A la espera de respuesta | Escriba para continuar",
    "OVERRIDE": "Escriba para continuar",
    "ACCEPT_RESPONSE": "Respuesta aceptada",
    "AGENT_ENTERED": "Agente ingresado",
    "EXPECTED_FORMAT": "Formato esperado",
    "INPUT_VALUES": "Valores de entrada",
    "RESTART": "Reiniciar",
    "START_OVER": "Empezar de nuevo",
    "RESTART_CAPTURE": "Reiniciar con las entradas capturadas",
    "CANCEL": "Cancelar",
    "INTERRUPT_DIALOG": "TAREA DE DIÁLOGO INTERRUMPIDA",
    "RUN": "Ejecutar",
    "RUN_AGENT": "Ejecutar con la entrada del agente",
    "STEP": "Paso",
    "DIALOG_TASK": "Tarea de diálogo",
    "TAB_TEXT":"No hay pestañas habilitadas! Por favor, habilita al menos una pestaña",
    "FAQ": "FAQ",
    "SNIPPET": "Respuestas",
    "ARTICLE": "Páginas Web",
    "FILE": "Archivos",
    "SUGGESTED": "Sugerido",
    "ALL_DIALOG": "Todas las tareas de diálogo",
    "DIALOG_TEXT": "Diálogo",
    "INTENT_IDENTIFIED": "Expresión del cliente",
    "NOT_WHAT_LOOKING": "¿Sugerencia incorrecta?",
    "BOT": "Bot",
    "CUSTOMER": "Cliente",
    "YOU": "Tú",
    "TERMINATE_CONV": "Terminar la tarea de diálogo",
    "TERMINATE_CONV_DESC": "¿Estás seguro de que quieres terminar la tarea de diálogo? Agent AI ya no podrá hacer sugerencias.",
    "YES_TERMINATE": "Sí, terminar",
    "NO_CANCEL": "No, cancelar",
    "OVERRIDE_CONTINUE": "Continuar con el modo de anulación",
    "SUMMARY_TEXT": "Resumen",
    "SUBMIT": "Enviar",
    "INTERRUPT_OCCURED": "Interrupción ocurrida",
    "IDENTIFIED_INTENT": "Intención identificada",
    "INTERRUPT_DESC": "Al ejecutar esto, se terminaría su tarea de diálogo en curso.",
    "ACCEPT_RUN": "Aceptar y ejecutar",
    "RUN_LATER": "Ejecutar más tarde",
    "KNOW_MORE": "Saber más",
    "MORE_TEXT": "Más",
    "LESS_TEXT": "Menos",
    "VIEW_MORE": "Ver más",
    "VIEW_LESS": "Ver menos",
    "SHOW_MORE_FAQ": "Mostrar más preguntas frecuentes",
    "SHOW_LESS_FAQ": "Mostrar menos preguntas frecuentes",
    "SHOW_MORE_ARTICLE": "Mostrar más páginas web",
    "SHOW_LESS_ARTICLE": "Mostrar menos páginas web",
    "SHOW_MORE_SNIPPET": "Mostrar más respuestas",
    "SHOW_LESS_SNIPPET": "Mostrar menos respuestas",
    "SHOW_MORE_FILES": "Mostrar más archivos",
    "SHOW_LESS_FILES": "Mostrar menos archivos",
    "VIEW_ALL_DIALOG": "Ver todos los diálogos",
    "VIEW_FEW_DIALOG": "Ver pocos diálogos",
    "HELP_FULL": "¿Útil?",
    "THANKYOU": "Gracias",
    "EXPAND_MORE": "Expandir \/ Más",
    "CLOSE_TEXT": "Cerrar",
    "STARTED": "Iniciado",
    "ENDED": "Finalizado",
    "VIEW_FULL_ARTICLE": "Ver página web completa",
    "VIEW_FULL_FILE": "Ver archivo completo",
    "COPIED": "Copiado",
    "SENTI_ANALY": "Análisis de sentimientos",
    "WRONG_SUGGESTION": "Sugerencia incorrecta",
    "INCORRECT_INTENT": "Intención incorrecta",
    "ACCIDENTAL_CLICK": "Clic accidental",
    "TIME_TAKING": "Lleva tiempo",
    "OTHER": "Otro",
    "PLAYBOOK_EMPTY_MSG": "Seleccionar playbook",
    "PLAYBOOK_EMPTY_DESC": "Agent AI no puede cargar el playbook porque todos los playbooks disponibles son dinámicos. Haga clic en 'Seleccionar playbook' para acceder al playbook",
    "STAGE": "Etapa",
    "PROCEED_TO_CLOSE": "Continuar para cerrar",
    "RECOMENDED_PLAYBOOK": "PLAYBOOK RECOMENDADO",
    "PRIMARY_SCRIPTS": "SCRIPTS PRIMARIOS",
    "DYNAMIC_SCRIPTS": "SCRIPTS DINÁMICOS",
    "RESUME": "Continuar",
    "ENABLE_CLOSE": "Haga clic en el botón \"Continuar para cerrar\" para habilitar el cierre de la etapa",
    "LIST_VIEW": "Vista de lista",
    "TERMINATE": "Terminar",
    "MINIMIZE": "Minimizar",
    "MAXIMIZE": "Maximizar",
    "NO_SEARCH_RESULT": "No se encontraron resultados de búsqueda",
    "SENTIMENT_AWAITING": "Esperando sentimiento",
    "POSITIVE": "Positivo",
    "NEGATIVE": "Negativo",
    "COPY" : "Copiar",
    "PLAYBOOK": "Libro de jugadas",
    "TELL_US_MORE": "Cuéntanos más",
    "THANKS_FEEDBACK": "Gracias por tus comentarios",
    "SOMETHING_WRONG": "Algo salió mal",
    "CLICK_ERROR_DETAILS": "Haz clic para ver los detalles del error",
    "NO_ACTIVE_PLAYBOOK": "No hay manual de estrategias activo",
    "REPHRASE_QUESTION": "¿Podrías reformular tu pregunta o preguntar algo más?",
    "INTERNAL_INFO": "Información interna",
    "SOURCES": "Fuentes",
    "CONVERSATION_SUMMARY": "Resumen de la conversación",
    "WAITING": "Esperando",
    "WIDGET_DISABLED": "Widget deshabilitado",
    "AI_SETTINGS_DISABLED": "¡Configuración de IA deshabilitada! Ponte en contacto con el administrador de IA",
    "SERVER_CONNECTION_ERROR": "Error al conectar con el servidor",
    "VIEW": "Ver",
    "ATTACHMENT_INPUT": "Entrada de adjunto",
    "TYPE_SUMMARY": "Escribir resumen",
    "VIEW_FULL_ARTICLE_2": "Ver artículo completo",
    "VIEW_FULL_FILE_2": "Ver archivo completo",
    "BY":"Por",
    GENERATE_SUMMARY: "Generar resumen",
    PREV_SUMMARIES: "Resúmenes generados previamente",
    DIALOG_WORKFLOWS: "Flujos de trabajo de diálogo",
    SHOW_ALL_DIALOG: "Mostrar todas las tareas de diálogo",
    SHOW_ALL_DIALOGS: "Mostrar todos los diálogos",
    CUSTOM_TAB: "Pestaña personalizada",
    AGENT_INPUT: "Entrada del agente",
    "CUSTOM_EMPTY_MSG" : "No hay flujo de trabajo activo",
    "CUSTOM_TAB_DESC" : "Para iniciar un flujo de trabajo, ejecute uno de la lista que se encuentra en la parte inferior de la pantalla.",
    "SUBMIT_OVERALL_FEEDBACK" : "Enviar comentario general",
    "FEEDBACK_POPUP_SUBTITLE" : "Comentarios sobre el widget y sus funciones",
    "FEEDBACK_SATISFIED" : "Satisfecho",
    "FEEDBACK_UNSATISFIED" : "No satisfecho",
    "FEEDBACK_PROVIDE_REASONS" : "Proporcionar más información…",
    "FEEDBACK_TITLE" : "Comentario",
    "AGENTIC_THINKING" : "Pensando",
    "AGENTIC_AGENT_TITLE" : "Agente",
    "AGENTIC_COPILOT_MODE_TITLE" : "Modo Copiloto Agéntico",
    "AGENTIC_SENDING_MESSAGE" : "Enviando...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot está escuchando activamente tu conversación y listo para asistir automáticamente",
    "AGENTIC_SEARCH_RESULTS" : "Resultados Agénticos",
    "PAUSE_AUTO_SEND" : "Pausar Envío Automático",
    "PAUSE_AGENTIC" : "Pausar Agéntico",
    "RESUME_AGENTIC" : "Reanudar Agéntico",
    "RESUME_AUTO_SEND" : "Reanudar Envío Automático"
}